export enum PostTradingEventTypeEnum {
	EXPIRED = 'OPEXP',
	EXERCISES = 'OPEXC',
	ASSIGNED = 'OPASN',
}
